import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useLayoutEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AppShell } from "../components/AppShell";
import { AuthPage } from "../features/auth/AuthPage";
import { ExplorePage } from "../features/explore/ExplorePage";
import { VenuePage } from "../features/explore/VenuePage";
import { HomePage } from "../features/home/HomePage";
import { NotificationsPage } from "../features/notifications/NotificationsPage";
import { PlanDetailPage } from "../features/plans/PlanDetailPage";
import { PlanResultsPage } from "../features/plans/PlanResultsPage";
import { ProfilePage } from "../features/profile/ProfilePage";
import { ReviewPage } from "../features/reviews/ReviewPage";
import { PaymentReturnPage } from "../features/reservations/PaymentReturnPage";
import { PlansPage } from "../features/reservations/PlansPage";
import { ReservationPage } from "../features/reservations/ReservationPage";
import { ReservePage } from "../features/reservations/ReservePage";
import { VenueReservePage } from "../features/reservations/VenueReservePage";
import { useAppStore } from "../state/appStore";
import { applyTimeTheme, timeThemeFor } from "../theme/timeTheme";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30000, retry: 2, refetchOnReconnect: true },
    mutations: { retry: 0 },
  },
});
const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/explore", element: <ExplorePage /> },
      { path: "/venues/:id", element: <VenuePage /> },
      { path: "/plans", element: <PlansPage /> },
      { path: "/profile", element: <ProfilePage /> },
    ],
  },
  { path: "/plan-results", element: <PlanResultsPage /> },
  { path: "/plans/:id", element: <PlanDetailPage /> },
  { path: "/auth", element: <AuthPage /> },
  { path: "/reserve/:planId", element: <ReservePage /> },
  { path: "/venues/:id/reserve", element: <VenueReservePage /> },
  { path: "/reservations/:id", element: <ReservationPage /> },
  { path: "/payment-return", element: <PaymentReturnPage /> },
  { path: "/notifications", element: <NotificationsPage /> },
  { path: "/reviews/:venueRequestId", element: <ReviewPage /> },
]);
export function isNightStart(startTime: string) {
  return timeThemeFor(startTime) === "night";
}
export function TimeTheme() {
  const startTime = useAppStore((state) => state.draft.startTime);
  useLayoutEffect(() => {
    applyTimeTheme(startTime);
  }, [startTime]);
  return null;
}
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TimeTheme />
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
